export default __webpack_public_path__ + "static/media/Sciences.95854895.gif";